export const POPOVER_TOOLTIP = 'tooltip';
export const POPOVER_FLYOUT = 'flyout';

export const darkTooltipOnly = (popoverType) => popoverType === POPOVER_TOOLTIP;
export const darkFlyoutOnly = (popoverType) => popoverType === POPOVER_FLYOUT;
